import { Globals } from "../App";
import { MessageFactory } from "./messages";
import { Protocol } from "./constants";

export const requestBetReplay = (id) => {
  const getRound = MessageFactory.createMessage(Protocol.GET_ROUND, id);
  return Globals.WS.sendMessage(getRound);
};
